import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../servicios/login-service.service';
//import { NgForm } from '@angular/forms';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators
} from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  formulario: FormGroup;
  iniciandoSesion = false;

  /*formulario = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
  });*/

  private sub: any;
  private results: any;
  title: string = 'Login';
  subtitle: string = 'Welcome owner';
  showSpinner: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private authService: LoginService,
    public router: Router,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    //alert("aqui");

    this.formulario = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    //alert(this.authService.getUserLoggedIn());

    if (this.authService.getUserLoggedIn() == '0') {
      //alert("si es falso");
      this.router.navigate(['login']);
    } else {
      //alert("Aqui");
      //alert("si es verdadero");
      this.router.navigate(['inicio']);
    }
    /*if (this.authService.getUserLoggedIn()) {
      this.router.navigate(['write']); // if user was logged in before, redirect to default landing page
    }*/
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    // stop here if form is invalid
    if (this.formulario.invalid) {
      return;
    }

    console.warn(this.formulario.value);
    //return;
    this.iniciandoSesion = true;
    this.authService.setUserLoggedIn(this.formulario.value).subscribe(
      data => {
        //alert(JSON.stringify(data));
        //alert();
        //console.log(JSON.stringify(data));
        let infoLogin = JSON.stringify(data);
        sessionStorage.setItem('infoUsuario', infoLogin);
        sessionStorage.setItem('token', data[0].token);
        sessionStorage.setItem('refresh_token', data[0].refresh_token);
        this.iniciandoSesion = false;
        //return;
        if (data.length === 1 && data[0].respuesta !=='ERROR') {
          // auth service returns boolean value
          console.log('validas credentials');
          this.router.navigate(['inicio']);
          location.reload();
        } else {
          console.log('invalid credentials');
        }
      },
      error => {
        this.iniciandoSesion = false;
      }
    );
  }
}
